/* Lumira de compagnie : se promène, fait coucou, danse, fait la sieste, parle, saute et se laisse attraper */
(() => {
  'use strict';
  const pet = document.querySelector('[data-pet]');
  if (!pet) return;
  try { if (sessionStorage.getItem('lumiPet') === 'off') return; } catch (e) { /* stockage indisponible */ }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sprite = pet.querySelector('[data-pet-sprite]');
  const bubble = pet.querySelector('[data-pet-say]');
  let lines = [];
  try { lines = JSON.parse(pet.querySelector('[data-pet-lines]').textContent).map((l) => l.trim()).filter(Boolean); } catch (e) { lines = []; }
  if (pet.dataset.page === 'product') lines.push('Elle vous plaît ? Hop, dans le panier ! 🛒', 'Touchez les photos pour les voir en grand 🔍');
  if (!lines.length) lines = ['Coucou ! 👋'];

  const STATES = ['is-walking', 'is-waving', 'is-dancing', 'is-sitting'];
  let x = 20, y = 0, dir = 1, target = 20, state = 'idle', stateUntil = 0, last = 0, sayTimer, nextTalk = 0;
  const width = () => pet.offsetWidth || 80;
  const maxX = () => Math.max(10, window.innerWidth - width() - 10);
  const place = () => { pet.style.setProperty('--px', x + 'px'); pet.style.setProperty('--py', y + 'px'); sprite.style.setProperty('--dir', dir); };
  const setState = (s, ms) => {
    STATES.forEach((c) => pet.classList.remove(c));
    state = s;
    if (s !== 'idle') pet.classList.add('is-' + s);
    stateUntil = performance.now() + ms;
  };
  const say = (txt, ms = 4000) => {
    clearTimeout(sayTimer);
    bubble.textContent = txt;
    pet.classList.add('is-talking');
    sayTimer = setTimeout(() => pet.classList.remove('is-talking'), ms);
  };
  const randomLine = () => lines[(Math.random() * lines.length) | 0];
  const pickNext = () => {
    const r = Math.random();
    if (r < .45) { target = 10 + Math.random() * maxX(); dir = target > x ? 1 : -1; setState('walking', 20000); }
    else if (r < .62) setState('waving', 2400);
    else if (r < .80) setState('dancing', 3200);
    else if (r < .90) setState('sitting', 5000);
    else setState('idle', 2000);
  };

  // Apparition : elle arrive en marchant depuis le bord gauche et dit coucou
  x = reduce ? 16 : -width(); target = 40 + Math.random() * 120; dir = 1;
  pet.hidden = false; place();
  if (reduce) { setState('idle', 1e9); setTimeout(() => say(lines[0]), 800); }
  else { setState('walking', 20000); setTimeout(() => { setState('waving', 2400); say(lines[0]); }, 2600); }
  nextTalk = performance.now() + 14000;

  /* ---------- Boucle d'animation ---------- */
  const tick = (now) => {
    const dt = Math.min(50, now - (last || now)); last = now;
    if (!reduce && !pet.classList.contains('is-dragging') && !pet.classList.contains('is-falling')) {
      if (state === 'walking') {
        const speed = window.innerWidth < 750 ? 38 : 55;
        x += dir * speed * dt / 1000;
        if ((dir > 0 && x >= target) || (dir < 0 && x <= target)) { x = target; setState('idle', 800); }
      } else if (now > stateUntil) pickNext();
      if (now > nextTalk && !pet.classList.contains('is-talking')) { say(randomLine()); nextTalk = now + 18000 + Math.random() * 14000; }
      x = Math.min(Math.max(x, -width()), maxX());
      place();
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  window.addEventListener('resize', () => { x = Math.min(x, maxX()); target = Math.min(target, maxX()); place(); });

  /* ---------- Toucher : saut + paillettes + une phrase ---------- */
  const poke = (cx, cy) => {
    pet.classList.remove('is-jumping'); void pet.offsetWidth; pet.classList.add('is-jumping');
    setTimeout(() => pet.classList.remove('is-jumping'), 850);
    setState('idle', 1200);
    say(randomLine());
    if (window.LagonFountain) window.LagonFountain(cx, cy, 120, 3);
    else if (window.LagonBurst) window.LagonBurst(cx, cy, 30, 2, 110);
  };
  sprite.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    const r = sprite.getBoundingClientRect(); poke(r.left + r.width / 2, r.top + r.height / 3);
  });

  /* ---------- Attraper et lâcher : elle retombe en douceur ---------- */
  let down = null;
  sprite.addEventListener('pointerdown', (e) => {
    down = { sx: e.clientX, sy: e.clientY, ox: x, oy: y, moved: false };
    sprite.setPointerCapture(e.pointerId);
  });
  sprite.addEventListener('pointermove', (e) => {
    if (!down) return;
    const dx = e.clientX - down.sx, dy = e.clientY - down.sy;
    if (!down.moved && Math.hypot(dx, dy) < 6) return;
    if (!down.moved) { down.moved = true; pet.classList.add('is-dragging'); setState('dancing', 1e9); say('Wiiii ! 🎈', 2000); }
    x = Math.min(Math.max(down.ox + dx, 0), maxX());
    y = Math.min(0, down.oy + dy);
    place();
  });
  const release = (e) => {
    if (!down) return;
    const wasDrag = down.moved; down = null;
    if (!wasDrag) { poke(e.clientX, e.clientY); return; }
    pet.classList.remove('is-dragging'); pet.classList.add('is-falling');
    let vy = 0;
    const fall = () => {
      vy += 1.2; y = Math.min(0, y + vy); place();
      if (y < 0) requestAnimationFrame(fall);
      else { pet.classList.remove('is-falling'); setState('idle', 600); poke(x + width() / 2, window.innerHeight - 40); }
    };
    requestAnimationFrame(fall);
  };
  sprite.addEventListener('pointerup', release);
  sprite.addEventListener('pointercancel', () => { down = null; pet.classList.remove('is-dragging'); y = 0; place(); setState('idle', 800); });

  /* ---------- La cacher pour la visite en cours ---------- */
  pet.querySelector('[data-pet-close]').addEventListener('click', () => {
    say('À tout à l\'heure ! 💜', 1200);
    setTimeout(() => { pet.hidden = true; }, 900);
    try { sessionStorage.setItem('lumiPet', 'off'); } catch (e) { /* ignore */ }
  });
})();
